
import { motion } from "framer-motion";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  // Updated variants to ensure text remains visible throughout transitions
  const pageVariants = {
    initial: {
      opacity: 0.5, // Increased from 0 to ensure some visibility
      y: 8,
    },
    in: {
      opacity: 1,
      y: 0,
    },
    out: {
      opacity: 0.5, // Increased from 0 to ensure some visibility
      y: -8,
    },
  };

  // Updated transition to be more gentle
  const pageTransition = {
    type: "tween",
    ease: "easeInOut", // Changed from "anticipate" for more predictable movement
    duration: 0.4, // Slightly faster transition
  };

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      className="min-h-screen w-full bg-background" // Added bg-background to ensure contrast with text
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
